<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Dashboard</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <vs-divider>ACTUALES</vs-divider>
      <div class="row">

        <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center ">
            <vs-button @click="$router.push('/funnel')" type="line" size="large">Originación</vs-button>
          </vx-card>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Dashboard"
}
</script>
